
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/blog/[slug]",
      function () {
        return require("private-next-pages/en/blog/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/blog/[slug]"])
      });
    }
  